export const enumToArray = (x: object): number[] =>{
    //console.log(x)
    return Object.keys(x)
        .filter(value => !isNaN(Number(value)))
        .sort((first:any,last:any)=>{return first-last})
        .map((value):number=>Number(value));
};